<template>
  <div v-if="inline" class="inline" :style="{ height }">
    <div class="loadme-dot">
      <div class="loadme-dot1"></div>
      <div class="loadme-dot2"></div>
    </div>
  </div>
  <div v-else class="final-loading-box">
    <div class="loadme-dot">
      <div class="loadme-dot1"></div>
      <div class="loadme-dot2"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: '100px'
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      timeout: null,
      visible: false
    };
  },
  created() {
    this.visible = false;
    this.timeout = setTimeout(() => {
      this.visible = true;
      this.timeout = null;
    }, 100);
  },
  destroyed() {
    this.timeout && clearTimeout(this.timeout);
  }
};
</script>

<style>
.final-loading-box {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background-color: rgba(255, 255, 255, 0.25); */
  z-index: 2;
  cursor: not-allowed;
  z-index: 9999999;
}
.loadme-dot {
  width: 40px;
  height: 40px;
  text-align: center;
  position: fixed;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
  -webkit-animation: loadme-dot-rotate 1.5s infinite linear;
  animation: loadme-dot-rotate 1.5s infinite linear;
  z-index: 100;
}

.loadme-dot {
  width: 40px;
  height: 40px;
  text-align: center;
  position: fixed;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
  animation: loadme-dot-rotate 1.5s infinite linear;
  z-index: 100;
}

.loadme-dot1,
.loadme-dot2 {
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: #fc6352;
  border-radius: 100%;
  -webkit-animation: loadme-dot-bounce 2s infinite ease-in-out;
  animation: loadme-dot-bounce 2s infinite ease-in-out;
}

.loadme-dot2 {
  top: auto;
  bottom: 0;
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

@keyframes loadme-dot-rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes loadme-dot-bounce {
  0%,
  100% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
}
</style>

<style lang="scss" scoped>
.inline {
  height: 100px;
  position: relative;

  .loadme-dot {
    position: absolute;
  }
  .loadme-dot1,
  .loadme-dot2 {
    background-color: #fc6352;
  }
}
</style>
